import { ICustomSchemaStore } from "@/shared/models/ICustomSchemaStore"
import { CdnSchemaType } from "./CdnSchemaType"

export const cdnSchemaStoreTypeMap: Record<
    CdnSchemaType,
    {
        injectableKey: string
        storeLocationProp: keyof ICustomSchemaStore
        storeSchemasProp: keyof ICustomSchemaStore
    }
> = {
    [CdnSchemaType.RuleSchema]: {
        injectableKey: 'DataCleaningSchemaService',
        storeLocationProp: 'ruleSchemaLocation',
        storeSchemasProp: 'ruleSchemas'
    },
    [CdnSchemaType.AnalysisConfigSchema]: {
        injectableKey: 'AnalysisConfigSchemaService',
        storeLocationProp: 'analysisConfigSchemaLocation',
        storeSchemasProp: 'analysisConfigSchemas'
    },
    [CdnSchemaType.CalculationSchema]: {
        injectableKey: 'CalculationSchemaService',
        storeLocationProp: 'calculationSchemaLocation',
        storeSchemasProp: 'calculationSchemas'
    },
    [CdnSchemaType.PlotSchema]: {
        injectableKey: 'PlottingSchemaService',
        storeLocationProp: 'plotSchemaLocation',
        storeSchemasProp: 'plotSchemas'
    },
    [CdnSchemaType.TableSchema]: {
        injectableKey: 'TablesSchemaService',
        storeLocationProp: 'tableSchemaLocation',
        storeSchemasProp: 'tableSchemas'
    },
    [CdnSchemaType.CustomReportSchema]: {
        injectableKey: 'CustomReportSchemaService',
        storeLocationProp: 'customReportsSchemaLocation',
        storeSchemasProp: 'customReportsSchemas'
    },
    [CdnSchemaType.AdvancedAnalysis]: {
        injectableKey: 'AdvancedAnalysisSchemaService',
        storeLocationProp: 'advancedAnalysisSchemaLocation',
        storeSchemasProp: 'advancedAnalysisSchemas'
    }
}